<!-- 创建时间2023/06/16 16:39:37 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：简介 -->
<template>
  <div>
    <template v-if="disabled">
      <div v-html="desc ? htmlDesc : '--'"></div>
    </template>
    <yxtbiz-richeditor
      v-else
      ref="bizRich"
      :content="htmlDesc"
      :max-length="2000"
      :org-code="orgCode"
      app-code="kng"
      function-name="richeditor"
      module-name="knowledge"
      :placeholder="$t('pc_kng_temp_msg_describe_course' /* 请描述课程内容，让你的课程更受欢迎 */)"
      @change="change"
    />
  </div>
</template>

<script>
export default {
  name: 'form-desc',
  inject: ['getInfo'],
  props: {
    htmlDesc: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orgCode: localStorage.orgCode
    };
  },
  watch: {
    htmlDesc: {
      immediate: true,
      handler(val) {
        if (this.$refs.bizRich && this.$refs.bizRich.getHtml() !== val) {
          this.$refs.bizRich.setHtml(val);
        }
      }
    }
  },
  computed: {
    info() {
      return this.getInfo();
    }
  },
  methods: {
    change() {
      this.$emit(
        'update:htmlDesc',
        this.$refs.bizRich && this.$refs.bizRich.getHtml()
      );
      this.$emit(
        'update:desc',
        this.$refs.bizRich && this.$refs.bizRich.getText()
      );
    }
  }
};
</script>